import { DatabaseInfo, Datasource, Capabilities, Aggregation } from './engine';

export interface IDatabasesManagementService {
  fetchDatabaseOrUseCache(databaseId: string, refresh?: boolean): Promise<DatabaseInfo>;
  getCurrentDatabase(): DatabaseInfo | undefined;
  refreshDatabaseInfo(): Promise<void>;

  fetchDatasourceOrUseCache(id: Datasource['id']): Promise<Datasource>;
  getDatasourceOfCurrentDatabase(): Datasource | undefined;

  fetchCapabilitiesOrUseCache(vendor: Datasource['driverName']): Promise<Capabilities>;
  getCurrentDatabaseCapabilities(): Capabilities;

  fetchAggregatorsOrUseCache(vendor: Datasource['driverName']): Promise<Aggregation[]>;
  getCurrentDatabaseAggregators(): Aggregation[];

  fetchDatabaseInfo(databaseId: string): Promise<DatabaseInfo>;
}

export class DatasourceRepositoryServiceError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'FETCH_DATASOURCE_ERROR';
  }
}

export class DatabaseRepositoryServiceError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'FETCH_DATABASE_ERROR';
  }
}
